// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M8.44769874,9.61506276 L8.44769874,10.3849372 L6.27196653,
				10.3849372 L6.27196653,9.66527197 C6.27196653,6.92050209
				9.43514644,7.37238494 9.58577406,5.34728033 C9.65271967,
				4.32635983 9.0334728,3.77405858 7.67782427,3.77405858
				C6.55648536,3.77405858 5.23430962,4.0083682 5.23430962,
				4.0083682 L5,2.46861925 C5,2.46861925 6.62343096,2
				7.79497908,2 C10.2719665,2 11.9958159,3.18828452
				11.8953975,5.31380753 C11.7447699,8.42677824 8.44769874,
				8.0083682 8.44769874,9.61506276 Z M7.39330544,14 C6.70711297,
				14 6.13807531,13.4309623 6.13807531,12.7447699 C6.13807531,
				12.041841 6.70711297,11.4728033 7.39330544,11.4728033 C8.09623431,
				11.4728033 8.64853556,12.041841 8.64853556,12.7447699 C8.64853556,
				13.4309623 8.09623431,14 7.39330544,14 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Question.js